import { Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ToastComponent } from 'src/app/components/toast/toast.component';
import { HttpErrorResponse } from '@angular/common/http';

export enum ToastType {
    information = 'information',
    warning = 'warning',
    success = 'success',
    error = 'error',
}

@Injectable()
export class NotificationService {
    private initialConfig: Partial<IndividualConfig> = {
        toastComponent: ToastComponent,
        disableTimeOut: true,
    };

    constructor(
        private toastService: ToastrService,
        private translateService: TranslateService,
    ) {}

    showSuccessNotificationByKey(translationKey: string, titleKey: string = 'Success'): void {
        this.showNotification(translationKey, titleKey, ToastType.success);
    }

    showInformationNotificationByKey(translationKey: string, titleKey: string = 'Information'): void {
        this.showNotification(translationKey, titleKey, ToastType.information);
    }

    showWarningNotificationByKey(translationKey: string, titleKey: string = 'Warning'): void {
        this.showNotification(translationKey, titleKey, ToastType.warning);
    }

    showErrorNotificationByKeyAndCorrelationId(correlationId: string, titleKey: string = 'Error',): void {
      
        this.showNotificationWithCorrelationId(correlationId,titleKey, ToastType.error);
    }

    showErrorNotificationByKey(translationKey: string, titleKey: string = 'Error'): void {
        this.showNotification(translationKey, titleKey, ToastType.error);
    }

    private showNotificationWithCorrelationId(correlationId: string, titleKey: string, type: ToastType, params: Partial<IndividualConfig> = {}): void {
        var errorMessage = "Please contact the administrator correlationId: " + correlationId
        this.toastService.show(errorMessage, titleKey, {
            ...this.initialConfig,
            ...params,
            payload: {type},
          });
      }

    private showNotification(translationKey: string, titleKey: string, type: ToastType, params: Partial<IndividualConfig> = {}): void {
        this.translateService.get([translationKey, titleKey])
          .subscribe({
            next: (translations: {[key: string]: string}) => {
              this.toastService.show(translations[translationKey], translations[titleKey], {
                ...this.initialConfig,
                ...params,
                payload: {type},
              });
            }
        });
      }
}
